import { useMemo } from 'react';
import useSWR from 'swr';
import { HandlersProfileHistoryResponse } from 'types/__generated__/SimInventoryApi';
import getFetcher from 'api/utils/getFetcher';
import { ApiBaseError } from '../utils/shared';

export interface SimProfileHistoryResultError extends ApiBaseError {}

const useSimProfileHistory = (hologramSimId?: HologramSimId) => {
  const url = hologramSimId
    ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/sims/${hologramSimId}/profiles/history`
    : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    HandlersProfileHistoryResponse,
    SimProfileHistoryResultError
  >(url, getFetcher);

  const profileHistory = useMemo(() => data?.profileHistory ?? [], [data]);

  return {
    profileHistory,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useSimProfileHistory;
